
import React from "react";
import { Sparkles, BookText, Tag, MessageSquare, Users } from "lucide-react";

export function AITabContent() {
  return (
    <div className="space-y-4">
      <div className="flex items-start">
        <Sparkles className="h-5 w-5 text-purple-500 mr-3 mt-1 flex-shrink-0" />
        <div>
          <h3 className="font-medium">AI-powered sermon suggestions</h3>
          <p className="text-gray-500 text-sm mt-1">
            Our AI assistant helps create sermon plans that are biblically sound, engaging, and relevant to your congregation.
          </p>
        </div>
      </div>
      
      <div className="bg-purple-50 border border-purple-100 rounded-md p-4 mt-2">
        <h4 className="text-sm font-medium text-purple-800 mb-2">What makes a good sermon:</h4>
        <ol className="list-decimal list-inside text-xs text-purple-700 space-y-1">
          <li>Strong biblical foundation that connects scripture to the message</li>
          <li>Clear central thesis or "big idea" that guides the entire message</li>
          <li>Logical structure with clear introduction, body, and conclusion</li>
          <li>Relevant applications for daily Christian living</li>
          <li>Engaging language and relatable examples</li>
        </ol>
      </div>

      <div className="border rounded-md p-4 bg-gray-50 mt-4">
        <h4 className="text-sm font-medium mb-3 flex items-center">
          <Sparkles className="h-4 w-4 mr-2 text-purple-600" />
          AI Will Help With:
        </h4>
        
        <div className="grid grid-cols-2 gap-3">
          <div className="border rounded p-2 bg-white">
            <div className="flex items-center mb-1">
              <BookText className="h-3 w-3 text-purple-600 mr-1" />
              <span className="text-xs font-medium">Content Structure</span>
            </div>
            <p className="text-xs text-gray-600">Logical organization of ideas</p>
          </div>
          
          <div className="border rounded p-2 bg-white">
            <div className="flex items-center mb-1">
              <Tag className="h-3 w-3 text-purple-600 mr-1" />
              <span className="text-xs font-medium">Scripture Insights</span>
            </div>
            <p className="text-xs text-gray-600">Contextual understanding</p>
          </div>
          
          <div className="border rounded p-2 bg-white">
            <div className="flex items-center mb-1">
              <MessageSquare className="h-3 w-3 text-purple-600 mr-1" />
              <span className="text-xs font-medium">Application Points</span>
            </div>
            <p className="text-xs text-gray-600">Practical relevance</p>
          </div>
          
          <div className="border rounded p-2 bg-white">
            <div className="flex items-center mb-1">
              <Users className="h-3 w-3 text-purple-600 mr-1" />
              <span className="text-xs font-medium">Engaging Examples</span>
            </div>
            <p className="text-xs text-gray-600">Relatable illustrations</p>
          </div>
        </div>
      </div>
    </div>
  );
}
